"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validVariablesEntries = exports.getClonableObject = exports.getClonableMessage = exports.getClonableError = exports.generateId = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
/** Avoids sonar validation */
var random = Math.random,
  floor = Math.floor;

/**
 * Validate that a string can be used as a variable name
 * https://stackoverflow.com/questions/2008279/validate-a-javascript-function-name
 */
var validArgumentRegex = /^[$A-Z_][0-9A-Z_$]*$/i;

/** Generates a random alpha-numeric ID of 10 characters */
var generateId = exports.generateId = function generateId() {
  return (0, _toConsumableArray2.default)(Array(10)).map(function () {
    return floor(random() * 36).toString(36);
  }).join('');
};

/** Returns an object with keys and values from the object passed by parameters */
var validVariablesEntries = exports.validVariablesEntries = function validVariablesEntries(variables) {
  return Object.entries(variables).filter(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
      key = _ref2[0];
    return validArgumentRegex.test(key);
  }).reduce(function (accum, _ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return {
      keys: [].concat((0, _toConsumableArray2.default)(accum.keys), [key]),
      values: [].concat((0, _toConsumableArray2.default)(accum.values), [value])
    };
  }, {
    keys: [],
    values: []
  });
};
var getClonableObject = exports.getClonableObject = function getClonableObject(object, replacer) {
  return JSON.parse(JSON.stringify(object, replacer));
};
var getClonableError = exports.getClonableError = function getClonableError(error) {
  return getClonableObject(error, ['message', 'stack']);
};

/**
 * Returns a message that can be clonable by the worker
 * using the original message as a base
 */
var getClonableMessage = exports.getClonableMessage = function getClonableMessage(value) {
  var _value$result;
  if (value.error) {
    return {
      error: value.error.message
    };
  }

  /**
   * If object has a especial field toDescription prints this value due to
   * backwards compatibility when creating a client
   */
  if ((_value$result = value.result) !== null && _value$result !== void 0 && _value$result.toDescription) {
    return {
      result: value.result.toDescription()
    };
  }
  if (typeof value.result === 'function') {
    return {
      result: value.result.toString()
    };
  }
  if ((0, _typeof2.default)(value.result) === 'object') {
    return {
      result: getClonableObject(value.result)
    };
  }
  return {
    result: value.result
  };
};
//# sourceMappingURL=utils.js.map